import {
  ContactUsBlock,
  GoogleReviewsServer,
  GoogleServiceArea,
  ServiceBlock,
} from "@modes0/ui-components";
import {
  BUSINESS_NAME,
  contactDetails,
  googleDetails,
  metaTagsContact,
} from "@/content";
import { serviceBlockData } from "@/content/services/stand-alone-services";
import GoogleContactFormWidget from "@/widgets/contact-form/GoogleContactFormWidget";
import {PageSeo} from '@modes0/ui-components-seo';
import {seoSiteProfile} from '@/content/seo';

export default function ContactPage() {
  return (
    <div className="bg-white">
      <PageSeo meta={metaTagsContact} siteProfile={seoSiteProfile} includeBusinessSchema />
      <h1 className="sr-only">Contact {BUSINESS_NAME}</h1>

      <GoogleContactFormWidget className="bg-[#edf7fc] px-4 py-12 md:py-16" />

      <section className="bg-white px-4 py-10 md:py-14">
        <div className="mx-auto max-w-6xl">
          <ContactUsBlock
            contactDetails={contactDetails}
            title={`Contact ${BUSINESS_NAME}`}
            subtitle="Call, SMS or email about CCTV, alarms, access control, security guards, mobile patrols, fire alarm support or security cabling across Sydney."
            showHeader
            className="ozy-contact-tiles"
            extraTileClasses="rounded-[8px]"
            labels={{
              phoneHeading: "Call",
              smsHeading: "SMS",
              emailHeading: "Email",
              phoneNote:
                "Best for urgent security timing, patrol coverage or site access questions.",
              smsNote:
                "Useful for quick property details, photos or access notes.",
              emailNote:
                "Best for plans, existing system details, photos and detailed security requirements.",
            }}
          />
        </div>
      </section>

      <section className="bg-[#edf7fc] py-10 md:py-14">
        <ServiceBlock
          data={serviceBlockData}
          className="ozy-service-block"
          maxWidth="1400px"
          pointsClasses=""
        />
      </section>

      <section className="bg-white py-10 md:py-14">
        <GoogleServiceArea googleDetails={googleDetails} />
      </section>

      {googleDetails.googleReviewLink ? (
        <section className="bg-[#f5f8fb] px-4 py-10 md:py-14">
          <div className="mx-auto max-w-5xl">
            <GoogleReviewsServer
              googleDetails={googleDetails}
              buttonTitle={`Review ${BUSINESS_NAME}`}
            />
          </div>
        </section>
      ) : null}
    </div>
  );
}
